import { t } from '@/i18n';
import styles from './QuestionInput.module.css';

const MAX = 200;

interface QuestionInputProps {
  value: string;
  onChange: (v: string) => void;
}

export function QuestionInput({ value, onChange }: QuestionInputProps) {
  return (
    <div>
      <div className={styles.qlbl}>
        {t.spread.questionLabel}{' '}
        <span className={styles.qopt}>{t.spread.questionOptional}</span>
      </div>
      <div className={styles.wrap}>
        <textarea
          className={styles.area}
          placeholder={t.spread.questionPlaceholder}
          maxLength={MAX}
          rows={5}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        <div className={styles.foot}>
          <span className={styles.cnt}>
            {value.length}/{MAX}
          </span>
        </div>
      </div>
    </div>
  );
}
